import { createContext } from 'react';
import noop from 'lodash/noop';

import api from '../api';
import { Company } from '../types';
import { ModelOptions } from '../../../types';

interface Context<T> {
    get: (params?: Partial<T>, options?: ModelOptions, updateState?: boolean) => Promise<Array<T>>;
    post: (body: Partial<T>, updateState?: boolean, last?: boolean) => Promise<T>;
    put: (body: Partial<T>) => Promise<T>;
    remove?: (id: string) => Promise<string>;
    softDelete: (body: { _id: string }) => Promise<any>;
    data: T[];
    setData: (array: Array<T>) => void;
    selected: T | null;
    setSelected: (object: T) => void;
    error?: T | null | {};
}

export type CompanyContext = Context<Company>;
export default createContext<CompanyContext>({
    get: api.get,
    post: api.post,
    put: api.put,
    remove: api.remove,
    softDelete: api.softDelete,
    data: [],
    setData: noop,
    selected: null,
    setSelected: noop,
    error: null
});
